"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var ArrowForward_1 = __importDefault(require("@mui/icons-material/ArrowForward"));
var react_router_dom_1 = require("react-router-dom");
var Send_1 = __importDefault(require("@mui/icons-material/Send"));
var Tile_1 = __importDefault(require("@/frontend/react/components/Tile"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var Specifications_1 = __importDefault(require("../general/Specifications"));
var NotificationContext_1 = __importDefault(require("../context/NotificationContext"));
var Line_1 = __importDefault(require("../components/Line"));
var classes = {
    vacancyTitle: {
        marginTop: '2px',
        marginBottom: '12px',
        color: '#4b4b4b',
    },
    vacancySubTitle: {
        marginTop: '12px',
        color: '#4B4B4B',
    },
    organizationLogo: {
        width: 45,
        height: 45,
        '& > img': {
            objectFit: 'contain',
        },
    },
    referredLabel: {
        color: function (theme) { return theme.palette.primary.main; },
        marginBottom: 1,
    },
    saveVacancy: {
        position: 'absolute',
        top: '-10px',
        right: '-10px',
        padding: '16px',
        color: 'white',
        backgroundColor: function (theme) { return theme.palette.primary.main; },
        borderRadius: '50%',
        '&:hover': {
            backgroundColor: function (theme) { return theme.palette.primary.dark; },
        },
    },
};
var navLinkCss = function (theme) { return ({
    textDecoration: 'none',
    color: theme.palette.text.primary,
}); };
function ApplicationTile(_a) {
    var _b, _c, _d;
    var vacancy = _a.vacancy, applicationId = _a.applicationId;
    var statusParam = (0, react_router_dom_1.useParams)().status;
    var location = (0, react_router_dom_1.useLocation)();
    var notifications = (0, react_1.useContext)(NotificationContext_1.default).notifications;
    var hasNotification = typeof notifications.applications[applicationId] !== 'undefined';
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, __assign({ to: "".concat(applicationId, "/about"), css: navLinkCss }, { children: (0, jsx_runtime_1.jsxs)(Tile_1.default, __assign({ active: location.pathname.includes("/applications/".concat(statusParam, "/").concat(applicationId)) }, { children: [vacancy.suggestedBy && ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, sx: classes.referredLabel }, { children: [trans_1.default.get('strings.frontend.application.suggested_by', { user: vacancy.suggestedBy }), (0, jsx_runtime_1.jsx)(Line_1.default, { backgroundColor: "#CDCDCD" })] }))), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(material_1.Avatar, { variant: "square", src: (_b = vacancy.organization) === null || _b === void 0 ? void 0 : _b.logo, alt: (_c = vacancy.organization) === null || _c === void 0 ? void 0 : _c.name, sx: classes.organizationLogo }) })), (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ sx: classes.saveVacancy }, { children: (0, jsx_runtime_1.jsx)(Send_1.default, { sx: { transform: 'rotateY(0deg) rotate(-45deg)' } }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, sx: classes.vacancyTitle }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6", sx: { fontWeight: 'bold' } }, { children: (0, html_react_parser_1.default)(vacancy.title) })) })), (0, jsx_runtime_1.jsx)(Specifications_1.default, { vacancy: vacancy }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, sx: classes.vacancySubTitle }, { children: (0, jsx_runtime_1.jsxs)(material_1.Typography, { children: [(_d = vacancy.organization) === null || _d === void 0 ? void 0 : _d.name, " | ", vacancy.locationAddress] }) })), hasNotification && ((0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ display: "flex", fontWeight: "bold", gap: 2, mt: 2 }, { children: [trans_1.default.transChoice('strings.frontend.new_messages_amount', notifications.applications[applicationId], {
                            amount: notifications.applications[applicationId].toString(),
                        }), (0, jsx_runtime_1.jsx)(ArrowForward_1.default, { color: "primary" })] })))] })) })));
}
exports.default = ApplicationTile;
